import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TuneIcon from '@mui/icons-material/Tune';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';
import Colors from '../colors';

function FilterAccordion({ children, isExpanded, setIsExpanded }) {

    const accordionStyle = {
        borderRadius: '20px',
        border: `1px solid ${Colors.gray}`,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.10)',
        width: '100%',
        margin: '20px 0px',
    }

    const accordionSummaryStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }

    const accordionLabel = {
        fontFamily: 'Jost',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '20px',
        lineHeight: '116 %',
        display: 'flex',
        alignItems: 'center',
        color: Colors.darkGray,
        paddingLeft: '10px'
    }

    return (
        <div>
            <Accordion style={accordionStyle} expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    style={accordionSummaryStyles}
                >
                    <TuneIcon style={{ width: '26px', height: '26px' }} />
                    <span style={accordionLabel}>Filters</span>
                </AccordionSummary>
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default FilterAccordion;